import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import MOMOSection from "./components/MOMOSection";
import SocialSection from "./components/SocialSection";
import TeamSection from "./components/TeamSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <main style={{ backgroundColor: "oklch(0.10 0.001 10)" }}>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <MOMOSection />
      <SocialSection />
      <TeamSection />
      <ContactSection />
      <FooterSection />
    </main>
  );
}